import { name } from './name';
import { status } from './status';
import { created } from './created';
import { actions } from './actions';
import { namespace } from './namespace';

export const columns = [name, status, namespace, actions, created];
